import { render, staticRenderFns } from "./ContratosPantalla.vue?vue&type=template&id=0744a4f1&"
import script from "./ContratosPantalla.vue?vue&type=script&lang=ts&"
export * from "./ContratosPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports